document.addEventListener("DOMContentLoaded", () => {
    // Locate the form and its associated table
    const form = document.querySelector("form[id*=edit_invoice_approval]")
    const decisionInputWrapper = form?.querySelector("li#invoice_approval_decision_input")
    const rejectionReasonInputWrapper = form?.querySelector("li#invoice_approval_rejection_reason_input")
    const rejectionNotesInputWrapper = form?.querySelector("li#invoice_approval_rejection_notes_input")

    if (!decisionInputWrapper || !rejectionReasonInputWrapper || !rejectionNotesInputWrapper) return

    // --- Constants ---
    const HIDDEN = "hidden"
    const DECISION_REJECTION = "rejected"
    const REJECTION_REASON_OTHER = "other"
    const DECISION_CHECKED = 'input[name="invoice_approval[decision]"]:checked'
    const REJECTION_REASON_CHECKED = 'input[name="invoice_approval[rejection_reason]"]:checked'

    const toggleRejectionReasonVisibility = () => {
        const selectedDecision = decisionInputWrapper.querySelector(DECISION_CHECKED)
        const rejectionReasonInputs = rejectionReasonInputWrapper.querySelectorAll("input")
        if (!selectedDecision || selectedDecision.value !== DECISION_REJECTION) {
            rejectionReasonInputWrapper.classList.add(HIDDEN)
            rejectionReasonInputs.forEach(input => input.disabled = true)

            const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
            if (selectedRejectionReason) selectedRejectionReason.checked = false
        } else {
            rejectionReasonInputs.forEach(input => input.disabled = false)
            rejectionReasonInputWrapper.classList.remove(HIDDEN)
        }

        toggleRejectionNotesVisibility()
    }

    const toggleRejectionNotesVisibility = () => {
        const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
        const rejectionNotesInput = rejectionNotesInputWrapper.querySelector("textarea")

        if (!selectedRejectionReason || selectedRejectionReason.value !== REJECTION_REASON_OTHER) {
            rejectionNotesInputWrapper.classList.add(HIDDEN)
            rejectionNotesInput.disabled = true
        } else {
            rejectionNotesInput.disabled = false
            rejectionNotesInputWrapper.classList.remove(HIDDEN)
        }
    }

    const addEventListeners = () => {
        // Attach event listener to the parent (event delegation)
        decisionInputWrapper.addEventListener("change", toggleRejectionReasonVisibility)
        rejectionReasonInputWrapper.addEventListener("change", toggleRejectionNotesVisibility)
    }

    const addFormEventListener = () => {
        form.addEventListener("submit", (e) => {
            const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
            if (!selectedRejectionReason || selectedRejectionReason.value !== REJECTION_REASON_OTHER)
                rejectionNotesInputWrapper.remove()

            const selectedDecision = decisionInputWrapper.querySelector(DECISION_CHECKED)
            if (!selectedDecision || selectedDecision.value !== DECISION_REJECTION)
                rejectionReasonInputWrapper.remove()
        })
    }

    // Initialize state on page load
    toggleRejectionReasonVisibility()
    toggleRejectionNotesVisibility()

    addEventListeners()
    addFormEventListener()
})
